import { React } from '../react.js';

export function LoadingMark(props: { readonly label?: string }) {
  return (
    <span className="loading-mark" role="status" aria-label={props.label ?? 'Loading'}>
      <span/><span/><span/>
    </span>
  );
}
